import { GetterTree } from 'vuex'
import { PalettesState } from './palettes.types'

export const getters: GetterTree<PalettesState, unknown> = {
  palettes(state) {
    return state.palettes
  }
}
